if (!customElements.get('announcement-bar')) {
  customElements.define(
    'announcement-bar',
    class AnnouncementBar extends HTMLElement {
      constructor() {
        super();

        this.barHolder = this;
        this.locationPath = location.href;
        this.slides = this.barHolder.querySelectorAll('[data-slide]');
        this.slider = this.barHolder.querySelector('[data-slider]');
        this.static = this.barHolder.querySelector('[data-static]');
        this.parallax = this.barHolder.querySelector('[data-parallax-animation]');
        this.flkty = null;
      }

      connectedCallback() {
        this.removeAnnouncement();
        this.checkSlidesClasses();

        if (this.slider) {
          this.initSlider();

          if (this.onResizeWidth) {
            document.removeEventListener('theme:resize:width', this.onResizeWidth);
          }
          this.onResizeWidth = this.initSlider.bind(this);
          document.addEventListener('theme:resize:width', this.onResizeWidth);
        }

        this.updateSVGClipPathIDs();
      }

      /**
       * Delete announcement which has a target referrer attribute and it is not contained in page URL
       */
      removeAnnouncement() {
        for (let i = 0; i < this.slides.length; i++) {
          const element = this.slides[i];

          if (!element.hasAttribute('data-target-referrer')) {
            continue;
          }

          if (this.locationPath.indexOf(element.getAttribute('data-target-referrer')) === -1 && !window.Shopify.designMode) {
            element.parentNode.removeChild(element);
          }
        }
      }

      // This is used to hide the section based on the target device (e.g., if all slides are for mobile, hide the section on desktop).
      checkSlidesClasses() {
        if (this.slides.length !== 0) {
          const slidesMobile = this.barHolder.querySelectorAll('[data-slide].mobile');
          const slidesDesktop = this.barHolder.querySelectorAll('[data-slide].desktop');

          if (this.slides.length === slidesMobile.length) {
            this.barHolder.parentNode.classList.add('mobile');
          } else if (this.slides.length === slidesDesktop.length) {
            this.barHolder.parentNode.classList.add('desktop');
          }
        }
      }

      /**
       * Init slider
       */
      initSlider() {
        const slides = this.slider.querySelectorAll('[data-slide]');
        const sliderArrows = this.slider.hasAttribute('data-slider-arrows');

        if (slides) {
          let slideSelector = '[data-slide]';

          if (window.innerWidth < theme.sizes.small) {
            slideSelector = '[data-slide]:not(.desktop)';
          } else {
            slideSelector = '[data-slide]:not(.mobile)';
          }

          if (this.flkty != null) {
            this.flkty.destroy();
          }

          this.flkty = new window.theme.Flickity(this.slider, {
            cellSelector: slideSelector,
            pageDots: false,
            prevNextButtons: sliderArrows,
            wrapAround: true,
            autoPlay: parseInt(this.slider.getAttribute('data-slider-speed'), 10),
            on: {
              ready: () => {
                setTimeout(() => this.refresh(), 10);
              },
              change: (index) => {
                this.flkty.cells.forEach((slide, i) => {
                  slide.element.querySelectorAll('text-highlight').forEach((highlight) => {
                    highlight.setTriggerAttribute(Boolean(i === index));
                  });
                });
              },
            },
          });
          this.flkty.reposition();
        }
      }

      refresh() {
        // Refresh tickers
        this.querySelectorAll('ticker-bar')?.forEach((tickerBar) => {
          if (typeof tickerBar.resizeEvent === 'function') {
            tickerBar.resizeEvent();
          }
        });

        // Fix SVG clip-path IDs
        this.updateSVGClipPathIDs();
      }

      updateSVGClipPathIDs() {
        this.barHolder.querySelectorAll('[data-slide]').forEach((svg, index) => {
          const clipPath = svg.querySelector('clipPath');

          if (clipPath) {
            const newclipPathId = `${clipPath.id}_${index}`;

            // Update the clipPath ID
            clipPath.id = newclipPathId;

            // Update the 'clip-path' URL reference in the <g> tag
            const gTag = svg.querySelector('g[clip-path]');
            if (gTag) {
              gTag.setAttribute('clip-path', `url(#${newclipPathId})`);
            }
          }
        });
      }

      disconnectedCallback() {
        if (this.onResizeWidth) {
          document.removeEventListener('theme:resize:width', this.onResizeWidth);
        }
      }
    }
  );
}
